"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { makeDataField } from './index.mjs';
import { DataBuilderComponentsProvider } from './components-context.mjs';
import DataBuilderCondition from './Condition/index.mjs';
import { DataBuilderProvider } from './data-builder-context.mjs';
import { DataBuilderFormField } from './DataBuilderFormField.mjs';
import DataBuilderFormFieldValue from './FieldValue/index.mjs';
import { DataBuilderForm } from './Form.mjs';
import { FormComponentsProvider } from './form-components-context.mjs';
import { formulaComponentMapping } from './Formula/index.mjs';
import DataBuilderFormNested from './Nested.mjs';
import { FormulaComponentsProvider } from './Formula/formula-components-context.mjs';

function FilterInput({
  value,
  variablesSchema,
  onChange
}) {
  const field = makeDataField({
    value,
    variablesSchema
  });
  return /* @__PURE__ */ jsx(FormComponentsProvider, { DataBuilderForm, children: /* @__PURE__ */ jsx(FormulaComponentsProvider, { mapping: formulaComponentMapping, children: /* @__PURE__ */ jsx(
    DataBuilderComponentsProvider,
    {
      Nested: DataBuilderFormNested,
      FieldValue: DataBuilderFormFieldValue,
      DataBuilderFormField,
      children: /* @__PURE__ */ jsx(DataBuilderProvider, { topLevelField: field, children: /* @__PURE__ */ jsx("div", { className: "max-w-full", children: /* @__PURE__ */ jsx(DataBuilderCondition, { field, onChange }) }) })
    }
  ) }) });
}

export { FilterInput };
